module.exports = __webpack_public_path__ + "img/1513218794.74e2ee9d.jpg";